import './productListing.scss';

import Accessory from './Accessory';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AccessoriesFilteredProduct } from '../../models/accessoriesFilteredProduct';

type AccessoriesListingProps = {
    columns: any;
    products: AccessoriesFilteredProduct[];
    categories: any[];
    template: any;
};

export default function AccessoriesListing(props: AccessoriesListingProps) {
    const { columns, products, categories, template } = props;

    const { t } = useTranslation('templatePages');

    const capitalizeFirstLetter = (sentence: string) => {
        if (typeof sentence !== 'string') return '';
        return sentence.charAt(0).toUpperCase() + sentence.slice(1);
    };

    return (
        <div className={`productListing col-${columns}`}>
            <div className='container'>
                {products.length === 0 ? (
                    <strong className='resultNumber'>{t('no-result')}</strong>
                ) : (
                    <React.Fragment>
                        <strong className='resultNumber'>
                            {products.length} {t('results')}
                        </strong>

                        <table className='partsTable'>
                            <tbody>
                                {categories.map((category) => {
                                    if (
                                        category.id !==
                                            '/Century/Accessories/' &&
                                        category.id !== '/Century/Venting/' &&
                                        category.id !==
                                            '/Century/Venting/Single wall stove pipe/' &&
                                        category.id !==
                                            '/Century/Venting/Double wall stove pipe/' &&
                                        category.id !==
                                            '/Century/Venting/Stainless flex liner/'
                                    ) {
                                        const sectionName =
                                            template === 'Venting'
                                                ? `${
                                                      category.type
                                                  } - ${capitalizeFirstLetter(
                                                      category.name
                                                  )}`
                                                : capitalizeFirstLetter(
                                                      category.name
                                                  );
                                        return [
                                            <tr
                                                key={category.id}
                                                className='categoryName'
                                            >
                                                {products.filter(
                                                    (product) =>
                                                        product.product.category ===
                                                        category.id
                                                ).length > 0 && (
                                                    <td colSpan={5}>
                                                        <h4>{sectionName}</h4>
                                                    </td>
                                                )}
                                            </tr>,
                                            products.map((product, index) => {
                                                if (
                                                    product.product.category ===
                                                    category.id
                                                ) {
                                                    return (
                                                        <Accessory
                                                            key={`accessory-${index}`}
                                                            product={product}
                                                            hasOwnPage={true}                                                      />
                                                    );
                                                } else {
                                                    return undefined;
                                                }
                                            }),
                                        ];
                                    } else {
                                        return undefined;
                                    }
                                })}
                            </tbody>
                        </table>
                    </React.Fragment>
                )}
            </div>
        </div>
    );
}